import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PageLayout, Section } from "./ui/Layout";
import { TabNavigation } from "./ui";
import MABNewsFeed from "./MABNewsFeed";
import KeywordsManagement from "./KeywordsManagement";
import UserFeedbackTable from "./UserFeedbackTable";
import ManualRuns from "./ManualRuns";
import { Box } from "@mui/material";

const News_Page = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("tab1");
  const [isPopup, setIsPopup] = useState(false);

  // Check if we're in popup mode
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    setIsPopup(urlParams.get("popup") === "true");
  }, []);

  // Handle navigation state from keyword management pages
  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  // Tab configuration
  const tabs = [
    { value: "tab1", label: "MAB News Feed" },
    { value: "tab2", label: "Keywords Management" },
    { value: "tab3", label: "User Feedback" },
    { value: "tab4", label: "Manual Runs" },
  ];

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // If in popup mode, show only the MAB News Feed without tabs and navigation
  if (isPopup) {
    return <MABNewsFeed standalone={true} />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Tab Navigation */}
      <Section sx={{ pb: 0, pt: 1, flexShrink: 0 }}>
        <TabNavigation
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={handleTabChange}
        />
      </Section>

      {/* Tab Content */}
      {activeTab === "tab1" && (
        <Section
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <MABNewsFeed />
        </Section>
      )}

      {activeTab === "tab2" && (
        <Section
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <KeywordsManagement />
        </Section>
      )}

      {activeTab === "tab3" && (
        <Section
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <UserFeedbackTable />
        </Section>
      )}

      {activeTab === "tab4" && (
        <Section
          sx={{
            flex: 1,
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <ManualRuns />
        </Section>
      )}
    </Box>
  );
};

export default News_Page;
